module.exports = __webpack_public_path__ + "static/media/Transaction_Icon.a973d290.png";